const terrain_manager = {

        // view structure
        title: String("Fincas"),
        terrainsDetailsTitle: String("Detalles de la finca, {terrain_name}"),
        terrainsDetailsNewTerrainTitle: String("Crear nueva finca"),
        
        // Profile fields
        terrainName: String("Nombre de la finca"),
        terrainGoogleAskAddress: String("Puedes utilizar la siguiente entrada para buscar la dirección o bien rellenar manualmente los campos"),
        terrainAddressStreet: String("Dirección"),
        terrainAddressNumber: String("Número"),
        terrainAddressMunicipality: String("Municipio"),
        terrainAddressMunicipalityCode: String("Código Municipio"),
        terrainAddressProvince: String("Provincia"),
        terrainAddressPostalCode: String("Código postal"),
        terrainAddressRegion: String("Región o comarca"),
        terrainAddressCountry: String("Pais"),

        // Tech fields
        terrainArea: String("Superficie (en Hectáreas)"),
        terrainElevation: String("Altitud (sobre el nivel del mar)"),
        terrainHomogeneousGrowingArea: String("Zona homogenea de cultivo"),
        terrainCoordinates: String("Coordernadas"),

        // Report fields
        reportFrequency: String("Periodo de envio"),
        terrainFrequencyInfoPopover: String("Frecuencia a la que se enviaran los informes de este terreno. El envio se realiza una vez se cumpla el periodo establecido desde el último envio y a primera hora del día."),
        reportLatestSent: String("Fecha y hora del último envio:"),
        reportEmails: String("Correos electrónicos de reporte"),
        terrainEmailsInfoPopover: String("Los correos electrónicos listados a continuación serán aquellos que recibiran los informes de este terreno."),
        terrainReportEmailPlaceholder: String("Introduce aquí el correo electrónico"),

        // Plots fields
        terrainPlotAddNew: String("Añadir nueva parcela"),
        terrainPlotNameHeader: String("Nombre de la parcela"),
        terrainPlotActionHeader: String("Acciones"),
        terrainPlotCropTypeHeader: String("Tipo de cultivo"),
        terrainPlotAreaHeader: String("Superficie de la parcela"),
        terrainPlotSigpacCodeHeader: String("Código SIGPAC"),
        terrainPlotActionModify: String("Modificar"),
        terrainPlotNoPlotInList: String("No hay ninguna parcela asociada a esta finca."),
        
        // Buttons
        terrainNewTerrainButton: String("Crear finca"),
        terrainUpdate: String("Actualizar datos de la finca"),
        terrainRestore: String("Restablecer todos los campos"),
        
        // Selector
        weekly: String("Semanal"),
        daily: String("Diario"),
        monthly: String("Mensual"),
        yearly: String("Anual"),

        // Nav buttons
        profileNavButton: String("Datos de explotación"),
        plotsNavButton: String("Lista de Parcelas"),
        reportNavButton: String("Personalizar informe"),

        // Popovers
        terrainNameInfoPopover: String("El nombre de la finca se hara referencia desde los informes así como la gestión de parcelas."),
        terrainAddressStreetInfoPopover: String("Dirección postal de la finca."),
        terrainAddressNumberInfoPopover: String("Número. En case de ser una dirección sin número, dejarlo por defecto."),
        terrainAddressMunicipalityInfoPopover: String("Municipio al que pertenece la finca."),
        terrainAddressMunicipalityCodeInfoPopover: String("Código del municipio. En caso de no saberse, dejarlo por defecto."),
        terrainAddressProvinceInfoPopover: String("Provincia de la finca."),
        terrainAddressPostalCodeInfoPopover: String("Código postal."),
        terrainAddressRegionInfoPopover: String("Región a la que pertenece la provincia o municipio."),
        terrainAddressCountryInfoPopover: String("País de la finca."),
        terrainAreaInfoPopover: String("Superficie de la finca en Hectáreas."),
        terrainElevationInfoPopover: String("Altitud respecto el nivel del mar."),
        terrainHomogeneousGrowingAreaInfoPopover: String("Zona homogenea de cultivo. Nombre simbolico para agrupar por zonas del mismo tipo de cultivo."),
        terrainCoordinatesInfoPopover: String("Coordenadas de la finca. Debe tener el siguiente formato: latitud, longitud"),

        // Placeholders
        terrainNamePlaceholder: String("Nombre de la finca..."),
        terrainGoogleAskAddressPlaceholder: String("Busca aqui la dirección..."),
        terrainAddressStreetPlaceholder: String("Calle o poligono..."),
        terrainAddressNumberPlaceholder: String("0"),
        terrainAddressMunicipalityPlaceholder: String("Municipio o ciudad..."),
        terrainAddressMunicipalityCodePlaceholder: String("00000"),
        terrainAddressProvincePlaceholder: String("Provincia..."),
        terrainAddressCountryPlaceholder: String("País..."),
        terrainAddressRegionPlaceholder: String("Región..."),
        terrainAddressPostalCodePlaceholder: String("00000"),
        terrainHomogeneousGrowingAreaPlaceholder: String("Zona 0"),
        terrainCoordinatesPlaceholder: String("41.1164879, 1.2623967"),

        // Validation errors
        errorFieldRequired: String("Este campo es obligatorio"),
        errorInvalidLength: String("Este campo require un mínimo de {length} caracteres"),
        errorNegativeNumber: String("Solo números positivos"),
        errorCoordinatesIncorrect: String("El formato de las coordenadas es incorrecto."),
        errorNameAlreadyExists: String("Ya existe una finca con este nombre."),
        errorsModalTitle: String("Errores en la finca"),
        errorsModalBodyTitle: String("No se ha podido crear/actualizar la finca debido a los siguientes errores:"),
        errorProfileFieldsLeft: String("Alguno de los campos del apartado de Datos de explotación es inválido o esta incompleto."),
        errorReportFieldsLeft: String("Alguno de los campos del apartado de Personalizar informe es inválido o esta incompleto."),
        errorsModalCloseButton: String("Cerrar"),
        errorEmailInvalid: String("Correo electrónico invalido"),

        // report request
        reportRequestTitle: String("Menú de descarga de informes"),
        reportRequestTerrainNoModules: String("No se ha generado el informe porque no hay estaciones asociadas a la finca"),
        reportRequestDownloadButton: String("Descargar el informe"),
        reportRequestWaitingForResponse: String("Generando el informe"),
};

export default terrain_manager;